import { render, staticRenderFns } from "./certifi.vue?vue&type=template&id=39477b69&scoped=true"
import script from "./certifi.vue?vue&type=script&lang=js"
export * from "./certifi.vue?vue&type=script&lang=js"
import style0 from "./certifi.vue?vue&type=style&index=0&id=39477b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39477b69",
  null
  
)

export default component.exports